export const PAGINATION = {
  OVERVIEW_PAGE_SIZE: 20,
  CLIENT_ENTITIES_PAGE_SIZE: 50,
  CASES_PAGE_SIZE: 20,
  UNASSIGNED_ENTITIES_PAGE_SIZE: 50,
  ALL_CLIENT_ENTITIES_PAGE_SIZE: 20,
  CLIENT_ENTITIES_BY_BILLING_GROUP_PAGE_SIZE: 20,
};

export const URL_PARAMS = {
  FILTERS_PARAM: "filters",
  SORTS_PARAM: "sorts",
  PAGE_PARAM: "page",
  TAB_PARAM: "tab",
};

export const GRID_COLUMN_FILTER_DEBOUNCE_MS = 500;
export enum BILLING_GRID_NAMES {
  CLIENT_ARENA_ENTITIES = "CLIENT_ARENA_ENTITIES",
  CLIENT_OVERVIEW = "CLIENT_OVERVIEW",
  CLIENT_ARENA_ENTITIES_BY_BILLING_GROUP = "CLIENT_ARENA_ENTITIES_BY_BILLING_GROUP",
}

export const ARENA_EDITION_FILTER_VALUES = [
  "Full",
  "Institutional",
  "Sponsor",
  "Professional",
  "Gp_lite_self_serve",
];

export const PRODUCT_LINE_FILTER_VALUES = [
  "Software",
  "Fund Administration",
  "Fund Services",
  "Deal Services",
];

export const BILLING_STATUS_FILTER_VALUES = ["Billable", "Non-Billable"];

export const BILLING_PERMISSION_DENIED_ERROR_CODE = "BILLING_PERMISSION_DENIED";
export const ENTITY_HAS_OPEN_CR_ERROR_CODE = "ENTITY_HAS_OPEN_CR";
export const FAMILY_HAS_OPEN_CR_ERROR_CODE = "FAMILY_HAS_OPEN_CR";

export const EXISTING_REQUEST_TYPE_LABELS: Record<string, string> = {
  entity_mapping: "manual tagging case",
  first_capital_call_date: "Trigger Date case",
  rename: "rename case",
  remove: "remove case",
};

export const EXISTING_REQUEST_TYPE_FALLBACK_LABEL = "change request";

export const ENTITY_STATUS_FILTER_VALUES = ["Active", "Completed"];

export const AG_GRID_SET_FILTER_FIELDS = [
  "productLine",
  "edition",
  "entityStatus",
  "billingStatus",
];
